import { defineChain } from '../../utils/chain/defineChain.js';
export const hyperEvm = /*#__PURE__*/ defineChain({
    id: 999,
    name: 'HyperEVM',
    nativeCurrency: { name: 'HYPE', symbol: 'HYPE', decimals: 18 },
    blockExplorers: {
        default: {
            name: 'HyperEVMScan',
            url: 'https://hyperevmscan.io',
        },
    },
    rpcUrls: {
        default: {
            http: ['https://rpc.hyperliquid.xyz/evm'],
        },
    },
    testnet: false,
});
//# sourceMappingURL=hyperEvm.js.map